import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
// TODO this was causing problems with building... 
// import streamBuffers from "stream-buffers";
import QueryString from "query-string";
import { routeMatcher } from "route-matcher";
import { merge } from "../util/object.js";
var FAKE_FETCH_RESPONSE = Symbol("FAKE_FETCH_RESPONSE");
var OK = 200;
var CONTENT_TYPE_JSON = "application/json";
function respondWith(options) {
  var bodyUsedCount = 0;
  function checkBodyUsedCount(f) {
    return function () {
      bodyUsedCount = bodyUsedCount + 1;
      if (bodyUsedCount > 1) {
        // response has to be cloned to access both text and json functions
        return Promise.reject(new Error("body already used"));
      }
      return f.apply(void 0, arguments);
    };
  }
  options = options || {};
  var status = options.status || OK;
  var statusText = options.statusText || "OK";
  var headers = Object.assign({
    "Content-Type": CONTENT_TYPE_JSON
  }, options.headers);
  var ok = status >= 200 && status < 300;
  // TODO this was causing problems with building... 
  // const body = new streamBuffers.ReadableStreamBuffer();
  // body.put(options.body);
  // body.stop();

  return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, FAKE_FETCH_RESPONSE, true), "status", status), "statusText", statusText), "ok", ok), "headers", new Headers(headers)), "json", checkBodyUsedCount(function () {
    return Promise.resolve(options.json || JSON.parse(options.text));
  })), "text", checkBodyUsedCount(function () {
    return Promise.resolve(options.text);
  })), "clone", function clone() {
    return {
      json: function json() {
        return Promise.resolve(options.json);
      },
      text: function text() {
        return Promise.resolve(options.text);
      }
    };
  });
}
export var fakeFetch = function fakeFetch(routes) {
  function parseRoute(route) {
    var parsedRoute = /^(?:(\w*) )?(.*)$/.exec(route);
    return {
      method: parsedRoute[1] || "GET",
      path: parsedRoute[2]
    };
  }
  var parsedRoutes = Object.keys(routes).map(function (route) {
    var _parseRoute = parseRoute(route),
      method = _parseRoute.method,
      path = _parseRoute.path;
    var matcher = routeMatcher(path);
    var handler = typeof routes[route] === "function" ? routes[route] : function () {
      return routes[route];
    };
    return {
      method: method,
      path: path,
      matcher: matcher,
      handler: handler
    };
  });
  function getHandlerAndParams(method, path) {
    var route = parsedRoutes.filter(function (r) {
      return r.method === method;
    }).map(function (r) {
      return merge(r, {
        params: r.matcher.parse(path)
      });
    }).find(function (r) {
      return r.params !== null;
    });
    return route || {};
  }
  function getHeaders(options) {
    return options.headers || {};
  }
  function getPayload(options) {
    var headers = getHeaders(options);
    if (!options.body) {
      return null;
    }
    if (startsWith(headers["Content-Type"], "application/json")) {
      return JSON.parse(options.body);
    }
    if (startsWith(headers["Content-Type"], "application/x-www-form-urlencoded")) {
      return QueryString.parse(options.body);
    }
    return options.body;
  }
  function startsWith(string, head) {
    if (!string) {
      return false;
    }
    return string.indexOf(head) === 0;
  }
  return /*#__PURE__*/function () {
    var _fetch = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestedUrl, options) {
      var requestedMethod, parts, requestedPath, queryString, headers, query, data, _getHandlerAndParams, handler, params, isBodySet, isBodyAllowed, result, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            requestedUrl = requestedUrl || "";
            options = options || {};
            if (!(typeof requestedUrl !== "string")) {
              _context.next = 4;
              break;
            }
            throw new TypeError("Expected url to be a string, but got ".concat(_typeof(requestedUrl), " ").concat(requestedUrl, "."));
          case 4:
            requestedMethod = options.method || "GET";
            parts = requestedUrl.split("?");
            requestedPath = parts[0];
            queryString = parts[1];
            headers = getHeaders(options);
            query = QueryString.parse(queryString);
            data = getPayload(options);
            _getHandlerAndParams = getHandlerAndParams(requestedMethod, requestedPath), handler = _getHandlerAndParams.handler, params = _getHandlerAndParams.params;
            isBodySet = options.body !== undefined && options.body !== null;
            isBodyAllowed = requestedMethod !== "GET" && requestedMethod !== "HEAD";
            if (!(isBodySet && !isBodyAllowed)) {
              _context.next = 16;
              break;
            }
            throw new TypeError("Request with GET/HEAD method cannot have body");
          case 16:
            if (!(typeof handler !== "function")) {
              _context.next = 18;
              break;
            }
            throw new Error("No handler function for ".concat(requestedMethod, " \"").concat(requestedPath, "\" defined."));
          case 18:
            _context.next = 20;
            return handler({
              respondWith: respondWith,
              headers: headers,
              params: params,
              query: query,
              data: data
            });
          case 20:
            result = _context.sent;
            if (result) {
              _context.next = 25;
              break;
            }
            throw new TypeError("Handler function for \"".concat(requestedUrl, "\" returned undefined (expected response object or string)"));
          case 25:
            if (result[FAKE_FETCH_RESPONSE]) {
              response = result;
            } else if (typeof result === "string") {
              response = respondWith({
                status: OK,
                text: result
              });
            } else {
              response = respondWith({
                status: OK,
                json: result
              });
            }
          case 26:
            return _context.abrupt("return", Promise.resolve(response));
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    function fetch(_x, _x2) {
      return _fetch.apply(this, arguments);
    }
    return fetch;
  }();
};